import { createSelector } from '@ngrx/store';

import { AppState } from '@core/state';
import { createChildSelectors } from '@util/lib/ngrx-child-selectors';

import { initialState } from './list.reducers';

export const selectListState = (state: AppState) => state.list;

export const {
  selectCarrier: selectCarrierLists,
  selectCustomer: selectCustomerLists,
  selectFacility: selectFacilityLists,
  selectInventory: selectInventoryLists,
  selectItem: selectItemLists,
  selectOrder: selectOrderLists,
  selectReport: selectReportLists,
  selectShipment: selectShipmentLists,
  selectStatic: selectStaticLists,
  selectSystem: selectSystemLists,
  selectUser: selectUserLists,
} = createChildSelectors(selectListState, initialState);

//
// carrier lists
//
export const { selectCarrier: selectCarrierList } = createChildSelectors(selectCarrierLists, initialState.carrier);

export const selectDeliveryServiceCodeList = (carrier: string) =>
  createSelector(selectCarrierLists, (state) => state.deliveryServiceCode[carrier]);

//
// customer lists
//
export const {
  selectCustomer: selectCustomerList,
  selectAuthorized: selectCustomerAuthorizedList,
  selectCustomerStatus: selectCustomerStatusList,
} = createChildSelectors(selectCustomerLists, initialState.customer);

export const selectCustomerItemUomList = (custid: string, item: string) =>
  createSelector(selectCustomerLists, (state) => state.customerItemUom[`${custid}-${item}`]);

export const selectCustomerDictionaryList = (custid: string) => createSelector(selectCustomerLists, (state) => state.dictionary[custid]);

//
// facility lists
//
export const {
  selectFacility: selectFacilityList,
  selectAuthorized: selectFacilityAuthorizedList,
  selectFacilityStatus: selectFacilityStatusList,
} = createChildSelectors(selectFacilityLists, initialState.facility);

export const selectFacilityDictionaryList = (facility: string) =>
  createSelector(selectFacilityLists, (state) => state.dictionary[facility]);

//
// inventory lists
//
export const { selectInventoryClass: selectInventoryClassList, selectInventoryStatus: selectInventoryStatusList } = createChildSelectors(
  selectInventoryLists,
  initialState.inventory
);

//
// item lists
//
export const {
  selectCustomerProductGroup: selectCustomerProductGroupList,
  selectCustomerRateGroup: selectCustomerRateGroupList,
  selectProductGroup: selectProductGroupList,
} = createChildSelectors(selectItemLists, initialState.item);

//
// order lists
//
export const {
  selectOrderItemStatus: selectOrderItemStatusList,
  selectOrderPriority: selectOrderPriorityList,
  selectOrderStatus: selectOrderStatusList,
  selectOrderType: selectOrderTypeList,
} = createChildSelectors(selectOrderLists, initialState.order);

//
// report lists
//
export const {
  selectFolder: selectReportFolderList,
  selectFormat: selectReportFormatList,
  selectReports: selectReportReportsList,
} = createChildSelectors(selectReportLists, initialState.report);

//
// shipment lists
//
export const {
  selectShipmentTerms: selectShipmentTermsList,
  selectShipmentTypes: selectShipmentTypesList,
  selectCountryCode: selectCountryCodeList,
  selectStateOrProvince: selectStateOrProvinceList,
} = createChildSelectors(selectShipmentLists, initialState.shipment);

//
// static lists
//
export const { selectYesNo: selectYesNoList } = createChildSelectors(selectStaticLists, initialState.static);

//
// system lists
//
export const { selectSystemDefault: selectSystemDefaultList } = createChildSelectors(selectSystemLists, initialState.system);

//
// user lists
//
export const {
  selectUserGroup: selectUserGroupList,
  selectUserForm: selectUserFormList,
  selectUserStatus: selectUserStatusList,
} = createChildSelectors(selectUserLists, initialState.user);
